// Language mapping utilities for template library
export const LANGUAGE_MAPPING = {
  // Primary language codes
  en: "en",
  ja: "ja",
  es: "es",
  pt: "pt",
  fr: "fr",
  it: "it",
  zh: "zh",
  ru: "ru",
  de: "de",
  ar: "ar",
  hi: "hi",
  ko: "ko",
  th: "th",
  vi: "vi",
  id: "id",
  ms: "ms",
  tr: "tr",
  pl: "pl",
  nl: "nl",
  sv: "sv",
  da: "da",
  no: "no",
  fi: "fi",
  cs: "cs",
  sk: "sk",
  hu: "hu",
  ro: "ro",
  bg: "bg",
  hr: "hr",
  sr: "sr",
  sl: "sl",
  et: "et",
  lv: "lv",
  lt: "lt",
  uk: "uk",
  be: "be",
  kk: "kk",
  uz: "uz",
  ky: "ky",
  tg: "tg",
  mn: "mn",
  ka: "ka",
  hy: "hy",
  az: "az",
  fa: "fa",
  ur: "ur",
  bn: "bn",
  ta: "ta",
  te: "te",
  ml: "ml",
  kn: "kn",
  gu: "gu",
  pa: "pa",
  or: "or",
  as: "as",
  ne: "ne",
  si: "si",
  my: "my",
  km: "km",
  lo: "lo",
  tl: "tl",
} as const;

/**
 * Get the appropriate language code for template library
 * @param languageCode The current language code
 * @returns The mapped language code or 'en' as fallback
 */
export const getTemplateLanguage = (languageCode: string): string => {
  // Check if we have a direct mapping
  if (LANGUAGE_MAPPING[languageCode as keyof typeof LANGUAGE_MAPPING]) {
    return LANGUAGE_MAPPING[languageCode as keyof typeof LANGUAGE_MAPPING];
  }

  // Check for language family fallbacks
  const languageFamily = languageCode.split("-")[0];
  if (LANGUAGE_MAPPING[languageFamily as keyof typeof LANGUAGE_MAPPING]) {
    return LANGUAGE_MAPPING[languageFamily as keyof typeof LANGUAGE_MAPPING];
  }

  // Default to English
  return "en";
};

/**
 * Get supported languages for template library
 * @returns Array of supported language codes
 */
export const getSupportedTemplateLanguages = (): string[] => {
  return Object.keys(LANGUAGE_MAPPING);
};
